var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f7931a;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.79,26.59V3.46c.27-.01.5-.04.72-.04,7.76,0,15.52,0,23.28-.02.67,0,.84.21.79.82-.05.6-.04,1.2,0,1.8.04.54-.2.68-.69.66-.88-.03-1.75,0-2.63,0-5.84,0-11.69,0-17.53,0-.25,0-.7.1-.72.2-.06.47-.04.96.04,1.42.02.09.45.14.69.14,4.36,0,8.73,0,13.09,0,2.86,0,5.73,0,8.59,0,.25,0,.49,0,.77,0v18.13H1.79Zm21.53-7.36c1,0,1.72-.71,1.72-1.68,0-.97-.8-1.75-1.77-1.73-.95.02-1.68.79-1.67,1.75.01.99.71,1.66,1.73,1.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWallet);
export default __webpack_public_path__ + "static/media/Connect-Wallet.ab898f3fce667910179fa043867753f0.svg";
export { ForwardRef as ReactComponent };